<template>
  <form class="job-form" @submit.prevent="handleSubmit">
    <div v-if="editJob" class="mb-8">
      <h2>
        {{ "Edit Job Listing - " + jobForm.title }}
      </h2>
    </div>
    <div v-else class="mb-8">
      <h2>Add a Job</h2>
    </div>

    <section class="mb-10">
      <div class="w-full">
        <div class="w-full">
          <label for="job-title">Title<span class="text-red">*</span></label>
          <input
            id="job-title"
            v-model="jobForm.title"
            v-validate="'required'"
            type="text"
            placeholder="Title"
            name="title"
          />
          <small class="err-msg text-red block mt-2">
            {{ veeValidateErrors.first("title") }}
          </small>
        </div>
        <div class="w-full flex justify-between">
          <div class="w-1/2">
            <label for="job-company"
              >Company<span class="text-red">*</span></label
            >
            <input
              id="job-company"
              v-model="jobForm.company"
              v-validate="'required'"
              type="text"
              placeholder="Company"
              name="company"
            />
            <small class="err-msg text-red block mt-2">
              {{ veeValidateErrors.first("company") }}
            </small>
          </div>
          <div class="mt-5 inline-flex">
            <button
              class="p-4 bg-blue-light text-white "
              @click.prevent="isWidgetOpen = !isWidgetOpen"
            >
              Upload Company Logo
            </button>
            <span v-if="jobForm.companyLogo" class="ml-5 company-logo">
              <img :src="jobForm.companyLogo" alt="" />
            </span>
            <div v-if="isWidgetOpen" class="image-upload-widget">
              <AWSS3UploadWidget
                :serverUrl="serverUrl"
                :category="'joblistings-image-uploads'"
                @FILE_UPLOAD_SUCCESS="handleImageUpload"
                @CLOSE_BUTTON_CLICK="isWidgetOpen = !isWidgetOpen"
              />
            </div>
          </div>
        </div>

        <div class="w-1/2">
          <label for="job-location">Location</label>
          <input
            id="job-location"
            v-model="jobForm.location"
            type="text"
            placeholder="Location"
          />
        </div>

        <div class="mt-6">
          <div>Job Type</div>
          <div class="flex">
            <div class="flex items-center">
              <label for="job-type-job">Job</label>
              <input
                id="job-type-job"
                v-model="jobForm.jobTypeTags.job"
                class="mb-0 ml-3"
                type="checkbox"
              />
            </div>

            <div class="flex items-center ml-4">
              <label for="job-type-internship">Internship</label>
              <input
                id="job-type-internship"
                v-model="jobForm.jobTypeTags.internship"
                class="mb-0 ml-3"
                type="checkbox"
              />
            </div>
          </div>
        </div>

        <div class="w-full flex">
          <div class="w-1/2">
            <label for="job-salary">Salary Start (lpa)</label>
            <input
              id="job-salary-start"
              v-model="jobForm.salary.start"
              type="number"
              step="1"
            />
          </div>
          <div class="w-1/2">
            <label for="job-salary-end">Salary End (lpa)</label>
            <input
              id="job-salary-end"
              v-model="jobForm.salary.end"
              type="number"
              step="1"
            />
          </div>
        </div>
        <div class="w-full flex">
          <div class="w-1/2">
            <label for="job-salary">Experience (Min Years)</label>
            <input
              id="job-salary-start"
              v-model="jobForm.experience.min"
              type="number"
              step="1"
            />
          </div>
          <div class="w-1/2">
            <label for="job-salary-end">Experience (Max Years)</label>
            <input
              id="job-salary-end"
              v-model="jobForm.experience.max"
              type="number"
              step="1"
            />
          </div>
        </div>
        <div class="w-full flex">
          <div class="w-1/2">
            <label for="job-salary">Deadline</label>
            <input
              id="job-salary-start"
              v-model="jobForm.deadline"
              type="date"
            />
          </div>
          <div class="w-1/2">
            <label for="job-salary-end">Expiry Date</label>
            <input id="job-salary-end" v-model="jobForm.expiry" type="date" />
          </div>
        </div>

        <div class="w-full">
          <label for="job-application"
            >Application Link <span class="text-red">*</span></label
          >
          <input
            id="job-application"
            v-model.trim="jobForm.link"
            v-validate="{ url: { require_protocol: true }, required: true }"
            type="text"
            name="application link"
            @blur="addProtocol"
          />
          <small class="err-msg text-red block mt-2">
            {{ veeValidateErrors.first("application link") }}
          </small>
        </div>

        <div class="mt-5">
          <div class="w-full">
            <label class="block text-left"
              >Job Description <span class="text-red">*</span></label
            >
            <input
              id="job-desc"
              v-model="jobForm.description"
              v-validate="'required'"
              type="text"
              class="hidden"
              name="description"
            />
            <QuillEditor
              ref="myQuillEditor"
              v-model="jobForm.description"
              class="w-full ml-4"
              :options="quillEditorOptions"
            />
            <small class="err-msg text-red block mt-2">
              {{ veeValidateErrors.first("description") }}
            </small>
          </div>
        </div>

        <div class="mt-6">
          <label>Year Of Graduation</label>
          <div class="flex flex-wrap ml-4">
            <span
              v-for="year in Object.keys(jobForm.yearsOfGraduation)"
              :key="year"
              class="mr-4 flex items-center year-item pr-2"
            >
              <input
                :id="year"
                v-model="jobForm.yearsOfGraduation[year]"
                class="mb-0 mr-1"
                type="checkbox"
              />
              <label :for="year" class="year-label">{{ year }}</label>
            </span>
          </div>
        </div>

        <div class="mt-5">
          <label>Key Skills</label>
          <div class="flex justify-start flex-wrap ml-4">
            <div
              v-for="skill in Object.keys(jobForm.skills)"
              :key="skill"
              class="mr-4 w-1/5 skill-item flex items-center"
            >
              <input
                :id="`job-skills-${skill}`"
                v-model="jobForm.skills[skill]"
                class="mb-0 mr-1"
                type="checkbox"
              />
              <label
                :for="`job-skills-${skill}`"
                class="block w-full skill-label"
                :class="{
                  'skill-item-selected text-blue-dark': jobForm.skills[skill],
                }"
                >{{ skill }}</label
              >
            </div>
          </div>
        </div>

        <div>
          <div class="font-bold text-md mt-5">Suggest Courses</div>
          <div class="suggest_courses">
            <p
              v-if="jobForm.suggested_courses.length === 0"
              class="text-center mt-8"
            >
              No Suggestion courses added!
            </p>
            <div class="mt-2">
              <p class="mb-2">
                Select suggested courses from edyst course list or add new one
                if not listed
              </p>
              <VueSelect
                ref="courseSelector"
                v-model="jobForm.suggested_courses"
                :options="defaultSuggestedCourses"
                label="name"
                placeholder="Select suggested courses from edyst course list"
                :hideSelected="true"
                :closeOnSelect="false"
                :multiple="true"
                class="ml-3 w-full"
              />
              <!-- <p class="my-2">Select suggested courses</p> -->
              <div
                v-for="(suggest_course, index) in jobForm.suggested_courses"
                :key="index"
                class="w-full relative mt-2 ml-3"
              >
                <div class="suggestion-courses-container">
                  <div class="flex items-center w-full mb-2">
                    <label :for="`suggest-course-name-${index}`" class="w-1/6"
                      >Course Name</label
                    >
                    <div class="w-3/4 mr-2">
                      <input
                        :id="`suggest-course-name-${index}`"
                        v-model="suggest_course.name"
                        type="text"
                        class="w-full"
                      />
                    </div>
                  </div>
                  <div class="flex items-center w-full">
                    <label :for="`suggest-course-url-${index}`" class="w-1/6"
                      >Course URL</label
                    >
                    <div class="w-3/4 mr-2">
                      <input
                        :id="`suggest-course-url-${index}`"
                        v-model="suggest_course.course_url"
                        type="text"
                        class="w-full"
                      />
                    </div>
                  </div>
                  <img
                    class="cursor-pointer remove-suggestion-course"
                    style="width: 20px; height: 20px;"
                    src="/images/trash.png"
                    @click="removeSuggestionCourse(index)"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="text-right mt-2">
            <div
              class="rounded px-3 py-2 mt-3 mb-5 bg-grey hover:bg-grey-dark hover:text-white cursor-pointer float-right"
              @click="addSuggestCourse"
            >
              + Suggest New Course
            </div>
          </div>
        </div>

        <div class="mt-10">
          <input type="submit" value="Submit" />
        </div>
      </div>
    </section>
  </form>
</template>

<script>
import AWSS3UploadWidget from "@edyst/shared-components/src/components/AWSS3UploadWidget"
import { quillEditor } from "vue-quill-editor"
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"

export default {
  components: {
    QuillEditor: quillEditor,
    AWSS3UploadWidget,
    VueSelect,
  },
  data() {
    return {
      defaultSuggestedCourses: [
        {
          name: "Web Master Bootcamp: Frontend + Backend",
          course_url: "https://edyst.com/course-info/web-master-bootcamp",
        },
        {
          name: "Algorithms & Data Structures Bootcamp",
          course_url: "https://edyst.com/course-info/aads",
        },
        {
          name: "Python Programming: Intro + Advanced",
          course_url: "https://edyst.com/course-info/intro-python",
        },

        {
          name: "TCS CodeVita Test Preparation Pack",
          course_url: "https://edyst.com/course-info/codevita",
        },
        {
          name: "Java Programming: Intro + Advanced",
          course_url:
            "https://edyst.com/course-info/java-programming-full-time-jPGBP",
        },
        {
          name: "WIPRO Elite National Talent Hunt 2021",
          course_url: "https://edyst.com/course-info/wipro",
        },
        {
          name: "TCS NQT 2021 Preparation Pack",
          course_url: "https://edyst.com/course-info/tcs-nqt-2021",
        },
        {
          name: "Complete Coding Test & Interview Preparation Pack",
          course_url: "https://edyst.com/course-info/complete-coding",
        },
      ],
      quillEditorOptions: {
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [{ indent: "-1" }, { indent: "+1" }],
            ["clean"],
          ],
        },
        placeholder: "Enter job description...",
        readOnly: false,
        theme: "snow",
      },
      isWidgetOpen: false,
      serverUrl: `${siteConfig.siteURL}uploads/public`,
      jobForm: {
        title: "",
        company: "",
        location: "",
        jobTypeTags: { job: false, internship: false },
        salary: { start: 0, end: 0 },
        experience: { min: 0, max: 0 },
        deadline: "",
        expiry: "",
        link: "",
        yearsOfGraduation: {
          2017: false,
          2018: false,
          2019: false,
          2020: false,
          2021: false,
          2022: false,
          2023: false,
          2024: false,
          2025: false,
          "Other can apply": false,
        },
        skills: {
          ".NET": false,
          Android: false,
          AngularJS: false,
          "Apache Tomcat": false,
          API: false,
          Bash: false,
          C: false,
          "C Sharp (C#)": false,
          "C#": false,
          "C++": false,
          CSS: false,
          CSS3: false,
          Eclipse: false,
          Git: false,
          Github: false,
          Hadoop: false,
          Heroku: false,
          Hive: false,
          HTML: false,
          "HTML5 & CSS3": false,
          "iOS Development": false,
          Java: false,
          JavaScript: false,
          Jenkins: false,
          JUNIT: false,
          Linux: false,
          "Microsoft SQL Server": false,
          MongoDB: false,
          MySQL: false,
          "Objective-C": false,
          OpenCV: false,
          Oracle: false,
          Perl: false,
          PHP: false,
          PostgreSQL: false,
          Python: false,
          R: false,
          React: false,
          Redis: false,
          Ruby: false,
          "SCSS / SASS": false,
          Selenium: false,
          SQL: false,
          SQLite: false,
          Svn: false,
          Swift: false,
          Ubuntu: false,
          Unix: false,
          "Vue.Js": false,
          Xcode: false,
          XML: false,
          OOP: false,
          "Node.js": false,
        },
        companyLogo: "",

        suggested_courses: [],
      },
    }
  },
  computed: {
    editJob() {
      return !!this.$route.params.slug
    },
  },
  async created() {
    if (this.editJob) {
      this.fetchJob()
    }
  },
  methods: {
    addSuggestCourse() {
      this.jobForm.suggested_courses.push({
        name: "",
        course_url: "",
      })
    },
    async removeSuggestionCourse(index) {
      if (this.jobForm.suggested_courses[index].name) {
        const v = await this.$swal({
          title: "Remove Course",
          text: `Are you sure you want to remove\n${this.jobForm.suggested_courses[index].name}?`,
          buttons: {
            cancel: true,
            confirm: {
              text: "Remove",
              value: true,
            },
          },
        })
        if (!v) return
      }
      this.jobForm.suggested_courses.splice(index, 1)
    },
    addProtocol() {
      const { link } = this.jobForm
      if (link && link.indexOf("http://") === 0) {
        return
      }
      if (link && link.indexOf("https://") === -1) {
        this.jobForm.link = `https://${this.jobForm.link}`
      }
    },
    populateJobForm(data) {
      Object.keys(this.jobForm.skills).forEach(skill => {
        if (data.skills && data.skills.includes(skill)) {
          this.jobForm.skills[skill] = true
        }
      })
      this.jobForm.slug = data.slug
      if (data.suggested_courses && data.suggested_courses.length > 0) {
        this.jobForm.suggested_courses = data.suggested_courses
      } else {
        this.jobForm.suggested_courses = this.defaultSuggestedCourses
      }
      this.jobForm.company = data.company
      this.jobForm.title = data.title
      this.jobForm.location = data.location
      Object.keys(this.jobForm.jobTypeTags).forEach(tag => {
        if (data.job_type_tags && data.job_type_tags.includes(tag)) {
          this.jobForm.jobTypeTags[tag] = true
        }
      })
      Object.keys(this.jobForm.yearsOfGraduation).forEach(year => {
        if (
          data.years_of_graduation &&
          data.years_of_graduation.includes(Number(year))
        ) {
          this.jobForm.yearsOfGraduation[year] = true
        }
      })
      this.jobForm.experience.min = data.experience_min_years
      this.jobForm.experience.max = data.experience_max_years
      this.jobForm.salary.start = data.salary_start_lpa
      this.jobForm.salary.end = data.salary_end_lpa
      this.jobForm.deadline =
        data.deadline && new Date(data.deadline).toISOString().slice(0, 10)
      this.jobForm.expiry =
        data.expiry_date &&
        new Date(data.expiry_date).toISOString().slice(0, 10)
      this.jobForm.link = data.link
      this.jobForm.description = data.description
      this.jobForm.companyLogo = data.company_logo_html
    },
    formatJobPayload() {
      const data = {}
      data.title = this.jobForm.title
      data.company = this.jobForm.company
      data.location = this.jobForm.location
      data.salaryStartLPA = this.jobForm.salary.start
      data.salaryEndLPA = this.jobForm.salary.end
      data.experienceMinYears = this.jobForm.experience.min
      data.experienceMaxYears = this.jobForm.experience.max
      data.link = this.jobForm.link
      data.description = this.jobForm.description
      data.suggested_courses = this.jobForm.suggested_courses
      data.skills = Object.keys(this.jobForm.skills).filter(
        f => this.jobForm.skills[f]
      )
      data.yearsOfGraduation = Object.keys(
        this.jobForm.yearsOfGraduation
      ).filter(f => this.jobForm.yearsOfGraduation[f])

      const { deadline, expiry } = this.jobForm
      if (deadline) {
        data.deadline = this.jobForm.deadline
      }
      if (expiry) {
        data.expiryDate = this.jobForm.expiry
      }
      data.jobTypeTags = Object.keys(this.jobForm.jobTypeTags).filter(
        f => this.jobForm.jobTypeTags[f]
      )
      data.companyLogoHtml = this.jobForm.companyLogo
      return data
    },
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$noty.error("Please fix the errors and try again")
          return
        }

        const payload = this.formatJobPayload()
        this.axios({
          method: this.editJob ? "PUT" : "POST",
          url: `${siteConfig.siteURL}admin/jobpost${
            this.editJob ? `/${this.$route.params.slug}` : ""
          }`,
          data: payload,
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "x-access-token": localStorage.token,
            "x-api-key": process.env.VUE_APP_API_KEY_SECRET_TOKEN,
          },
        }).then(() => {
          this.$router.push({ name: "JobListings" })
          this.$noty.success("Successful", {
            layout: "bottomLeft",
            theme: "relax",
            timeout: 1000,
          })
        })
      })
    },
    handleImageUpload(awsImageUrl) {
      if (awsImageUrl) {
        setTimeout(() => {
          this.isWidgetOpen = false
        }, 1000)
        if (awsImageUrl) {
          this.jobForm.companyLogo = awsImageUrl
        }
        this.$noty.success("Image Upload successful", {
          layout: "bottomLeft",
          theme: "relax",
          timeout: 1000,
        })
      }
    },
    fetchJob() {
      this.axios({
        method: "GET",
        url: `${siteConfig.siteURL}jobpost/${this.$route.params.slug}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.populateJobForm(res.data)
      })
    },
  },
}
</script>

<style lang="postcss">
.job-form {
  max-width: 900px;
  margin: auto;
}
.job-form input[type="text"],
input[type="submit"] {
  width: 100%;
  margin-bottom: 10px;
}
input[type="checkbox"]:focus {
  outline: 1px solid #ccc;
}

.job-form .suggestion-courses-container input {
  margin-bottom: 0;
}

.job-form button {
  padding: 10px 20px;
  outline: none;
}
.job-form label {
  display: block;
  padding: 10px 0px;
  font-size: 16px;
  text-align: left;
}
.company-logo {
  width: 70px;
  height: 70px;
  background-position: center;
  background-size: cover;
}

.suggestion-courses-container {
  height: auto;
  padding: 0.5rem 2rem;
  border: 1px solid #dbdbdb;
  border-radius: 3px;
}
.suggestion-courses-container {
  border: none;
  background: #f2f7fa;
  font-size: 1rem;
}
.remove-suggestion-course {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.skill-item .skill-label,
.year-item .year-label {
  padding: 0.5rem 0;
  color: #5c5c5c;
  font-size: 0.9rem;
  cursor: pointer;
}

.skill-item,
.year-item {
  padding-left: 0.5rem;
  border-radius: 3px;
  cursor: pointer;
}

.skill-item input:checked + label,
.year-item input:checked + label {
  color: #3490dc;
}

.skill-item:hover,
.year-item:hover {
  background: #e4e4e4;
}
</style>
